// extracted by mini-css-extract-plugin
export default {"inputWrapper":"uZXvfAlpvJrgImC9hLbn","phoneNumberLabel":"Smq3x_P8NAAWakPydrBz","disabled":"rkIup8TZ9EUWBRJUgC_H"};